import { Menu } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { useCanFn } from "@/auth/permissions/use-permissions";
import { AppSidebarNav } from "@/components/layout/app-sidebar";
import { NAV_SECTIONS } from "@/components/layout/nav-items";
import { resolveNavSections } from "@/components/layout/resolve-nav-items";
import { LanguageMenu, ThemeMenu } from "@/components/layout/ui-settings";
import { UserMenu } from "@/components/layout/user-menu";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { NotificationBell } from "@/features/notifications/notification-bell";

export function AppShell() {
  const { t } = useTranslation("common");
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  // 権限に応じたナビの出し分け。permissions-check の結果をシェルで 1 回だけ引く
  const sections = resolveNavSections(NAV_SECTIONS, useCanFn());

  return (
    <div className="flex min-h-screen">
      <aside className="bg-sidebar text-sidebar-foreground hidden w-64 shrink-0 border-r md:block">
        <div className="flex h-14 items-center px-5 font-semibold">
          {t("appName")}
        </div>
        <AppSidebarNav sections={sections} />
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center gap-2 border-b px-4">
          <Sheet open={isMobileNavOpen} onOpenChange={setIsMobileNavOpen}>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="md:hidden"
                aria-label={t("appName")}
              >
                <Menu className="size-4" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="bg-sidebar w-64 p-0">
              <SheetTitle className="flex h-14 items-center px-5">
                {t("appName")}
              </SheetTitle>
              <AppSidebarNav
                sections={sections}
                onNavigate={() => setIsMobileNavOpen(false)}
              />
            </SheetContent>
          </Sheet>

          <div className="ml-auto flex items-center gap-1">
            <NotificationBell />
            <LanguageMenu />
            <ThemeMenu />
            <UserMenu />
          </div>
        </header>

        <main className="min-w-0 flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
